/**
 *
 * Fork Of Below -- In addition to taking paper can also take a set of Raphael Elements
 *	-- 7/6/2015: Optional parameter absolutePaperDimensions -- if provided
 *		will use it's height and width properties (opposed to that derived from the set, which could be relative) to use as the exports height and width attributes
 *		(numeric values converted to strings with pixels)
 * -- 7/10/2015: Optional parameter to not include html style tag on svg element; Default is No
 * -- 12/14/2021: Update some text element code from latest version on Github (3/8/2018)
 * -- 2/21/2022 -- Changes implemented with Text Stamps ( library is obsolete )
 * 	- take an array of elements, no longer a set with the assumption of a paper
 * 	- ability to handle export of text with multiple lines
 *
 * Raphael.Export https://github.com/ElbertF/Raphael.Export
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

(function(R) {
	/**
	* Escapes string for XML interpolation
	* @param value string or number value to escape
	* @returns string escaped
	*/
	function escapeXML(s) {
		if ( typeof s === 'number' ) return s.toString();

		var replace = { '<': 'lt', '>': 'gt', '"': 'quot', '\'': 'apos' };

		for ( var entity in replace ) {
			s = s.replace(new RegExp(entity, 'g'), '&' + replace[entity] + ';');
		}

		return s;
	}

	/**
	* Generic map function
	* @param iterable the array or object to be mapped
	* @param callback the callback function(element, key)
	* @returns array
	*/
	function map(iterable, callback) {
		var mapped = [],
			undef = 'undefined',
			i;

		// use an index iteration if we're dealing with an array
		if( typeof iterable.unshift != 'undefined'){
			var l = iterable.length;
			for ( i = 0; i < l; i++ ) {
				if( typeof iterable[i] != undef ){
					var value = callback.call(this, iterable[i], i);
					if( value !== null ) mapped.push(value);
				}
			}
		} else {
			for ( i in iterable ) {
				if ( iterable.hasOwnProperty(i) ) {
					var value = callback.call(this, iterable[i], i);
					if ( value !== null ) mapped.push(value);
				}
			}
		}

		return mapped;
	}

	/**
	* Generic reduce function
	* @param iterable array or object to be reduced
	* @param callback the callback function(initial, element, i)
	* @param initial the initial value
	* @return the reduced value
	*/
	function reduce(iterable, callback, initial) {
		for ( var i in iterable ) {
			if ( iterable.hasOwnProperty(i) ) {
				initial = callback.call(this, initial, iterable[i], i);
			}
		}

		return initial;
	}

	/**
	* Utility method for creating a tag
	* @param name the tag name, e.g., 'text'
	* @param attrs the attribute string, e.g., name1="val1" name2="val2"
	* or attribute map, e.g., { name1 : 'val1', name2 : 'val2' }
	* @param content the content string inside the tag
	* @returns string of the tag
	*/
	function tag(name, attrs, matrix, content) {
		if ( typeof content === 'undefined' || content === null ) {
			content = '';
		}

		if ( typeof attrs === 'object' ) {
			attrs = map(attrs, function(element, name) {
				switch ( name ) {
					case 'transform':
						return;

					case 'fill':
						if ( element.match(/^hsb/) ) {
							var hsb = element.replace(/^hsb\(|\)$/g, '').split(',');

							if ( hsb.length === 3 ) {
								element = R.hsb2rgb(hsb[0], hsb[1], hsb[2]).toString();
							}
						}
				}

				return name + '="' + escapeXML(element) + '"';
			}).join(' ');
		}

		return '<' + name + ( matrix ? ' transform="matrix(' + matrix.toString().replace(/^matrix\(|\)$/g, '') + ')" ' : ' ' ) + attrs + '>' +  content + '</' + name + '>';
	}

	/**
	* @return object the style object
	*/
	function extractStyle(node) {
		return {
			font: {
				family: typeof node.attrs.font === 'undefined' ? null : node.attrs.font.replace(/^.?"(\w+)".$/, '$1'),
				size:   typeof node.attrs['font-size'] === 'undefined' ? null : parseInt( node.attrs['font-size'] ),
				style: typeof node.attrs['font-style'] === 'undefined' ? null : node.attrs['font-style'],
				weight: typeof node.attrs['font-weight'] === 'undefined' ? null : node.attrs['font-weight']
			},
			anchor: typeof node.attrs['text-anchor'] === 'undefined' ? null : node.attrs['text-anchor']
		};
	}

	/**
	* @param style object from style()
	* @return string
	*/
	function styleToString(style) {
		// TODO figure out what is 'normal'
		// Tyler: it refers to the default inherited from CSS. Order of terms here:
		// 		  http://www.w3.org/TR/SVG/text.html#FontProperty
		var norm = 'normal',
			textAnchor = 'text-anchor: ' + ( style.anchor || 'middle' ) + '; ',
			font = style.font;
		// return 'font: normal normal normal 10px/normal ' + style.font.family + ( style.font.size === null ? '' : '; font-size: ' + style.font.size + 'px' );
		return textAnchor + [ 'font:',
				(font.style || norm), // font-style (e.g. italic)
				norm, // font-variant
				(font.weight || norm), // font-weight (e.g. bold)
				(font.size ? font.size + 'px' : '10px') + '/normal', // font-size/IGNORED line-height!
				font.family ].join(' ');
	}

	/**
	 * repairs the hex color which missed the '#'
	 * @param any string
	 * @return hexvalue of rgb
	 */
	function convertToHexColor(value) {

		if(/^[0-9A-F]{6}$/i.test(value)){
			value = '#' + value;
		}

		return value;
	}

	/**
	* Computes tspan dy using font size. This formula was empircally determined
	* using a best-fit line. Works well in both VML and SVG browsers.
	* @param fontSize number
	* @return number
	*/
	function computeTSpanDy(fontSize, line, lines) {
		if ( fontSize === null ) fontSize = 10;

		//return fontSize * 4.5 / 13
		return fontSize * 4.5 / 13 * ( line - .2 - lines / 2 ) * 3.5;
	}

	var serializer = {
		'text': function(node) {

            //
			//var style = extractStyle(node),
			//	tags = new Array,
			//	textLines = node.attrs['text'].toString().split('\n'),
			//	totalLines = textLines.length;
            //
            //
			//map(textLines, function(text, line) {
            //
			//	var attrs = reduce(
			//		node.attrs,
			//		function(initial, value, name) {
			//			if ( name !== 'text' && name !== 'w' && name !== 'h' ) {
			//				if ( name === 'font-size') value = parseInt(value) + 'px';
			//				if( name === 'stroke'){
			//					value = convertToHexColor(value);
			//				}
            //
			//				initial[name] = escapeXML(value.toString());
			//			}
			//			return initial;
			//		},
			//		{ style: styleToString(style) + ';' }
			//	);
            //
            //
			//	/**
			//	 * if text node has a class set, apply it to the attrs object
			//	 */
			//	if (node.node.className.baseVal != "" && node.node.className.baseVal !== undefined) {
			//		attrs["class"] = node.node.className.baseVal;
			//	}
            //
			//	tags.push(tag(
			//		'text',
			//		attrs,
			//		node.matrix,
			//		tag('tspan', { dy: computeTSpanDy(style.font.size, line + 1, totalLines) }, null, text.replace(/&/g, "&amp;"))
			//	));
			//});
            //
			//
			//return tags;


			// TODO: we may want to ensure consistent between browsers -- if not, generate

			var tSpans = Array.prototype.slice.call( node.node.childNodes );

			var tSpanContent = tSpans.map( function( tspan ) {
				return tag( 'tspan', { dy: tspan.getAttribute('dy') }, null, tspan.innerHTML ); //  text.replace(/&/g, "&amp;"
			}).join('');


			var textTag = tag('text', node.attrs, node.matrix, tSpanContent  );


			return [textTag]; // rather than just 'node.node.outerHTML' --> gives more control and will also apply custom data attributes

			//return [node.node.outerHTML]; // may need to put line breaks back in the text -- we may want ?

		},
		'path' : function(node) {

			var initial = ( node.matrix.a === 1 && node.matrix.d === 1 ) ? {} : { 'transform' : node.matrix.toString() };

			return tag(
				'path',
				reduce(
					node.attrs,
					function(initial, value, name) {
						if ( name === 'path' ) name = 'd';

						initial[name] = value.toString();

						return initial;
					},
					{}
				),
				node.matrix
				);
		}


		// Other serializers should go here
	};


	R.fn.toSVG = function( elements , absolutePaperDimensions, includeSVGStyleTag ) {

		var paperWidth =  absolutePaperDimensions.width,
			paperHeight =  absolutePaperDimensions.height,
			restore = { svg: R.svg, vml: R.vml },
			svg     = '<svg ' + (includeSVGStyleTag ? 'style="overflow: hidden; position: relative;" ' : '') +
				'xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="' + paperWidth + '" version="1.1" height="' + paperHeight + '">';

		R.svg = true;
		R.vml = false;

		for ( var n = 0; n < elements.length; n ++) {

			var node = elements[n];

			if ( node.node.style.display === 'none' ) continue;

			var attrs = '';

			// Use serializer
			if ( typeof serializer[node.type] === 'function' ) {
				svg += serializer[node.type](node);

				continue;
			}

			switch ( node.type ) {
				case 'image':
					attrs += ' preserveAspectRatio="none"';
					break;
			}

			for ( i in node.attrs ) {
				var name = i;

				switch ( i ) {
					case 'src':
						name = 'xlink:href';

						break;
					case 'transform':
						name = '';

						break;
				}

				if ( name ) {
					attrs += ' ' + name + '="' + escapeXML(node.attrs[i].toString()) + '"';
				}
			}

			svg += '<' + node.type + ' transform="matrix(' + node.matrix.toString().replace(/^matrix\(|\)$/g, '') + ')"' + attrs + '></' + node.type + '>';
		}

		svg += '</svg>';

		R.svg = restore.svg;
		R.vml = restore.vml;

		return svg;
	};
})(window.Raphael);



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/vendor/raphael.export.js
 ** module id = 388
 ** module chunks = 0
 **/